export default "__VITE_ASSET__$WnnmMM0__"